import { useMemo } from 'react';
import useMemoizedFn from './useMemoizedFn';
import { debounce } from '#helper';

const useDebounce = (fn, ms) => {
  const memoizedFn = useMemoizedFn(fn);

  return useMemo(
    () =>
      debounce((...args) => {
        memoizedFn(...args);
      }, ms),
    [memoizedFn, ms]
  );
};

export default useDebounce;
